import { graphql } from "generated/gql";

export const getPermissionsDocument = graphql(/* GraphQL */ `
  query GetUserPermissions($subdomain: String!, $collectionSiteSlug: String) {
    permissions(
      organisationSubdomain: $subdomain
      collectionSiteSlug: $collectionSiteSlug
    ) {
      isInvalidOrganisation
      isInvalidCollectionSite
      deactivated
    }
  }
`);
